import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77bc03bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=77bc03bc&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=77bc03bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc03bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77bc03bc')) {
      api.createRecord('77bc03bc', component.options)
    } else {
      api.reload('77bc03bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77bc03bc&scoped=true", function () {
      api.rerender('77bc03bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/index.vue"
export default component.exports